import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import MUIDataTable from 'mui-datatables'
import { IconButton, Tooltip } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { Button, Modal } from 'react-bootstrap'
import { useStore } from '../../stores/store'
import EditUser from './EditUser'
import PageLoader from '../../../design/components/loaders/PageLoader'

const UsersTable = () => {
  const { userStore } = useStore()
  const { getAllUsers, loading, setLoading, deleteUser, selectUser } = userStore
  const [show, setShow] = useState(false)
  const [rowsDeleted, setRowsDeleted]: any = useState()

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  useEffect(() => {
    userStore.loadAllUsers()
  }, [userStore])

  if (userStore.loadingInitial) return <PageLoader />

  const data = getAllUsers.map((m) => ({
    id: m.id,
    avatar: (
      <img
        alt='img'
        style={{ width: '60px' }}
        src={m.avatar ? `/images/avatar/avatar${m.avatar}.png` : '/images/avatar/avatar1.png'}
      />
    ),
    email: m.email,
    userRoles: m.userRoles.map((r) => `[${r}] `),
    action: m.userRoles.toString().includes('Administrator') ? (
      ''
    ) : (
      <Tooltip onClick={() => selectUser(m.email)} title='Edit'>
        <IconButton>
          <EditIcon />
        </IconButton>
      </Tooltip>
    ),
  }))

  const columns = [
    {
      name: 'avatar',
      label: 'Avatar',
      options: {
        filter: false,
        sort: false,
      },
    },
    { name: 'email', label: 'Email' },
    { name: 'userRoles', label: 'Roles' },
    {
      name: 'action',
      label: 'Edit',
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { width: '100px' },
        }),
      },
    },
  ]

  async function handleDelete() {
    setLoading(true)
    for await (const d of rowsDeleted.data) {
      const { email } = data[d.dataIndex]
      await deleteUser(email)
    }
    setRowsDeleted(null)
    handleClose()
    setLoading(false)
  }

  function openConfrimDelete(rowsDeleted: any) {
    handleShow()
    setRowsDeleted(rowsDeleted)
  }

  return (
    // DATA TABLE
    <div className='main'>
      <MUIDataTable
        title='User List'
        data={data}
        columns={columns}
        options={{
          responsive: 'vertical',
          viewColumns: true,
          selectableRows: 'multiple',
          rowsPerPage: 10,
          rowsPerPageOptions: [5, 10, 15, 20],
          tableBodyHeight: '60vh',
          onRowsDelete: openConfrimDelete,
        }}
      />
      {/* EDIT USER */}
      <Modal
        show={userStore.editUserModal}
        onHide={() => userStore.setEditUserModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <EditUser />
      </Modal>

      {/* CONFIRM DELETE BUTTON */}
      <Modal centered show={show} onHide={handleClose} className='confirmDelete'>
        <Modal.Header closeButton>
          <Modal.Title>User List</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to Delete these Users?</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button disabled={loading} variant='danger' onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default observer(UsersTable)
